module.exports = __webpack_public_path__ + "img/hyu_gallery4.eed7c8ff.jpg";